import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { DialogOptions } from '@lib/util';
import { CustomerDepartmentDto } from '../../types/CustomerDepartment';
import { DepartmentSelectionDialogComponent, SelectDepartmentDialogData } from './department-selection-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class DepartmentService {
    private readonly dialog = inject(MatDialog);


    /**
     * Opens a dialog to select one or more departments
     * @param alreadySelectedSuppliers - departmentIds of those departments that may be already selected
     */
    public selectDepartment(alreadySelectedDepartments: string[] = []): Observable<CustomerDepartmentDto | undefined> {
        const data: SelectDepartmentDialogData = new SelectDepartmentDialogData(alreadySelectedDepartments);
        const options = DialogOptions.MEDIUM(data);
        const dialogRef: MatDialogRef<DepartmentSelectionDialogComponent, CustomerDepartmentDto> = this.dialog.open<
            DepartmentSelectionDialogComponent,
            CustomerDepartmentDto[]
        >(DepartmentSelectionDialogComponent, options);

        return dialogRef.afterClosed();
    }
}
